import { legacy_createStore as createStore, applyMiddleware, compose } from 'redux';
import { multiClientMiddleware } from 'redux-axios-middleware';
import { routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import thunk from 'redux-thunk';
import logger from 'redux-logger';
import createRootReducer from '../reducers';

import { client, cardClient, oauthClient, bankClient, v2client } from '../axios/index'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ICustomWindow } from '../../../global.d';

export const history = createBrowserHistory();

const initialState = {};
const enhancers: any[] = [];

let middleware = [
	routerMiddleware(history),
	multiClientMiddleware(
		{
			default: {
				client,
			},
			card: {
				client: cardClient,
			},
			bank: {
				client: bankClient,
			},
			oauth: {
				client: oauthClient,
			},
			v2client: {
				client: v2client,
			},
		},
		{
			returnRejectedPromiseOnError: true,
		},
	),
	thunk,
];

if (process.env.NODE_ENV === 'development') {
	middleware = [...middleware, logger];
}

if (process.env.NODE_ENV === 'development') {
	if (typeof window.__REDUX_DEVTOOLS_EXTENSION__ === 'function') {
		enhancers.push(window.__REDUX_DEVTOOLS_EXTENSION__());
	}
}

const composedEnhancers = compose(
	applyMiddleware(...middleware),
	...enhancers,
);

export const store = createStore(
	createRootReducer(history),
	initialState,
	composedEnhancers,
);